<span>
  {{ data.message }}
</span>
